// extracted by mini-css-extract-plugin
module.exports = {"table":"table__2IC4p","art":"art__35848","thoughts":"thoughts__3CaJP","links":"links__1LycQ","about":"about__14mpy"};